import { __assign } from "tslib";
import React, { useContext } from 'react';
import { getDeviationType, getPremiumFolderProperties } from '../_helpers';
import { DeviationTypes } from '../../types/deviation';
import ImageDumbView from './Image';
import FilmDumbView from './Film';
import FreeformDumbView from './Freeform';
import StatusDumbView from './Status';
import PollDumbView from './Poll';
import CommissionDumbView from './Commission';
import UnknownDumbView from './Unknown';
import ErrorBoundary from '../../ErrorBoundary';
import LiteratureDumbView from './Literature';
import HiddenDumbView from './Hidden';
import { withMatureContext, SessionContext } from '../../Context';
import Flag from '../../redux/flags/Flag';
import { useFlag } from '../../redux/flags/hooks/useFlag';
var DeviationDumbView = function (props) {
    var isLoggedIn = useContext(SessionContext);
    var isUplifted = useFlag('cdc_new_thumbs');
    var canHavePremium = useFlag('premium_folders');
    var DumbView;
    if (!props.deviation) {
        return null;
    }
    var isPremiumLocked = getPremiumFolderProperties(props.deviation, canHavePremium).isPremiumLocked;
    if ((!props.showMatureContent && props.deviation.isMature) ||
        props.deviation.isBlocked ||
        (props.deviation.isAntisocial && !isLoggedIn) ||
        isPremiumLocked) {
        // We have extra check for anti-social because inside a saved editor
        // deviation we can have stale isBlocked value
        return React.createElement(HiddenDumbView, __assign({}, props));
    }
    switch (getDeviationType(props.deviation)) {
        // these types all have guaranteed thumb image
        case DeviationTypes.IMAGE:
        case DeviationTypes.FLASH:
        case DeviationTypes.PDF:
        case DeviationTypes.MOTIONBOOK:
            DumbView = ImageDumbView;
            break;
        case DeviationTypes.FILM:
            DumbView = isUplifted ? ImageDumbView : FilmDumbView;
            break;
        case DeviationTypes.JOURNAL:
            DumbView = FreeformDumbView;
            break;
        case DeviationTypes.LITERATURE:
            DumbView = LiteratureDumbView;
            break;
        case DeviationTypes.STATUS:
            DumbView = StatusDumbView;
            break;
        case DeviationTypes.POLL:
            DumbView = PollDumbView;
            break;
        case DeviationTypes.COMMISSION:
            DumbView = CommissionDumbView;
            break;
        default:
            DumbView = UnknownDumbView;
    }
    return (React.createElement(ErrorBoundary, { style: { width: props.width, height: props.height } },
        React.createElement(Flag, { condition: "page_perf", render: function () { return React.createElement(DumbView, __assign({ pagePerf: true }, props)); }, fallbackRender: function () { return React.createElement(DumbView, __assign({}, props)); } })));
};
DeviationDumbView.displayName = 'DeviationDumbView';
export default withMatureContext(DeviationDumbView);
//# sourceMappingURL=Dumbo.js.map